import { Component, forwardRef } from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validator
} from '@angular/forms';
import { BuildingAccessData } from '@artemis-software/wr-api';
import { AbstractFormControl } from '@shared/form-controls/abstract-form-control';
import { createForm } from '@sonofabit/ng-core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  standalone: false,
  selector: 'wr-building-access-form',
  templateUrl: './building-access-form.component.html',
  styleUrl: './building-access-form.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => BuildingAccessFormComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => BuildingAccessFormComponent),
      multi: true,
    }
  ],
})
export class BuildingAccessFormComponent extends AbstractFormControl<BuildingAccessData> implements Validator {

  readonly form = createForm(({ field }) => {
    return {
      propertyKey: field({ value: '' as string | null }),
      keySafeWithPosition: field({ value: '' as string | null }),
      codes: field({ value: '' as string | null }),
      entryCount: field({ value: null as number | null }),
    };
  });

  constructor() {
    super();
    this.form.valueChanges.pipe(takeUntilDestroyed()).subscribe(val => {
      this.value = val as BuildingAccessData;
      if (this.onValidatorChange) {
        this.onValidatorChange();
      }
    });
  }

  override writeValue(value: BuildingAccessData | undefined) {
    super.writeValue(value);
    if (value) {
      this.form.patchValue(value, { emitEvent: false });
    } else {
      this.form.reset({}, { emitEvent: false });
    }
  }

  override markAsTouched() {
    super.markAsTouched();
    this.form.markAllAsTouched();
  }

  override setDisabledState(isDisabled: boolean): void {
    super.setDisabledState(isDisabled);
    if (isDisabled) {
      this.form.disable({ emitEvent: false });
    } else {
      this.form.enable({ emitEvent: false });
    }
  }

  validate(_control: AbstractControl): ValidationErrors | null {
    return this.form.invalid ? { accessDataInvalid: true } : null;
  }

  private onValidatorChange?: () => void;

  registerOnValidatorChange(fn: () => void): void {
    this.onValidatorChange = fn;
  }
}
